import React from 'react';

const NotAuthUser = () => {
  return (
    <div>

    </div>
  )
}

export default NotAuthUser